import { render } from "./CreateBillDialog.vue?vue&type=template&id=ba351e04&ts=true&lang=pug"
import script from "./CreateBillDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateBillDialog.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__